var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"me-badge"},[_vm._t("default"),_vm._v(" "),(_vm.showBadge)?_c('div',{staticClass:"me-badge__dot",class:_vm.classes},[_vm._v(_vm._s(_vm.formatContent))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }